<modal [isOpen]="typeAuth.statusModal || false" [isOpenTwo]="statusTwoModal">
  <div
    class="primary-modal"
    [ngClass]="{
      'modal-type-sms': typeAuth.type === nameTypeSms,
      'modal-type-totp': typeAuth.type === nameTypeTotp,
      'status-two-modal': statusTwoModal
    }"
  >
    <header-modal
      [title]="translate.titleAuth || 'Two-Factor Authentication'"
      (action)="close()"
    ></header-modal>
    <div class="primary-modal__content-loading" *ngIf="isLoading">
      <mg-loading [loading]="true"></mg-loading>
    </div>
    <div class="primary-modal__content" *ngIf="!isLoading">
      <div
        class="primary-modal__content__title-sms"
        *ngIf="typeAuth.type === nameTypeSms"
      >
        <span>
          {{
            translate.textSms ||
              "We have sent a code to your cell phone and email"
          }}</span
        >
      </div>
      <div class="primary-modal__content__verify">
        <div class="primary-modal__content__verify__title-authentication pb-4">
          <span> {{ translate.textAuthCode }} </span>
        </div>
        <code-input
          [isCodeHidden]="false"
          [initialFocusField]="0"
          [codeLength]="
            typeAuth.type === nameTypeSms ? sizeCheckSms : sizeCheckTotp
          "
          (codeChanged)="onCodeChanged($event)"
          (codeCompleted)="onCodeCompleted($event)"
        >
        </code-input>
        <span class="error" *ngIf="isInvalidCode">
          {{ translate.invalidCode }}
        </span>
        <div
          class="primary-modal__content__verify__time-caducation"
          *ngIf="typeAuth.type === nameTypeSms"
        >
          <span> {{ translate.expire }} </span>
          <span *ngIf="minutes.toString().length === 1">0</span>
          <span>{{ minutes }}</span>
          <span>:</span>
          <span *ngIf="seconds.toString().length === 1">0</span>
          <span>{{ seconds }}</span>
        </div>
        <div
          class="primary-modal__content__verify__text-totop"
          *ngIf="typeAuth.type === nameTypeTotp"
        >
          <span>
            {{
              translate.textTotp ||
                'Please note, the TOTP key will not be available to view after this screen. If you lose the key for this user, you will need to generate a new key (rendering the current key invalid)."'
            }}
          </span>
        </div>
        <div
          class="primary-modal__content__verify__open-two-modal"
          *ngIf="typeAuth.type === nameTypeTotp"
        >
          <button class="button-open" (click)="viewTwoModal()">
            <span class="button-open__text">
              {{ translate.textButtonTotp || "How to add authentication" }}
            </span>
            <img
              src="https://cdn.mango-soft.com/mango-core/icon-open-tab.svg"
            />
          </button>
        </div>
        <div class="primary-modal__content__verify__button">
          <button
            (click)="check()"
            [ngClass]="{
              disabled:
                validationCode.length <
                  (typeAuth.type === nameTypeSms
                    ? sizeCheckSms
                    : sizeCheckTotp) || activeCheck
            }"
            [disabled]="
              validationCode.length <
                (typeAuth.type === nameTypeSms
                  ? sizeCheckSms
                  : sizeCheckTotp) && !activeCheck
            "
          >
            {{ translate.buttonCheck || "Check" }}
          </button>
        </div>
      </div>
    </div>
    <div class="footer-modal-auth">
      <button class="secundaryButton" (click)="close()">
        {{ translate.buttonCancel || "Cancel" }}
      </button>
      <button
        class="primaryButton"
        [ngClass]="{
          disabled:
            validationCode.length <
              (typeAuth.type === nameTypeSms ? sizeCheckSms : sizeCheckTotp) ||
            activeCheck
        }"
        [disabled]="
          validationCode.length <
            (typeAuth.type === nameTypeSms ? sizeCheckSms : sizeCheckTotp) &&
          !activeCheck
        "
        (click)="check()"
      >
        {{ translate.buttonCheck || "Check" }}
      </button>
    </div>
  </div>
  <div class="second-modal">
    <header-modal
      [title]="translate.titleInstructions || 'Instructions'"
      (action)="viewTwoModal()"
    ></header-modal>
    <div class="content-modal">
      <content-two-modal-desktop
        [text1]="translate.instructionOne"
        [text2]="translate.instructionTwo"
        [tex3]="translate.instructionTree"
        [qr]="qr"
      ></content-two-modal-desktop>
      <content-two-modal-mobile
        [instructionOneMobile]="translate.instructionOneMobile"
        [instructionTwoMobile]="translate.instructionTwoMobile"
        [instructionTreeMobile]="translate.instructionTreeMobile"
        [instructionFourMobile]="translate.instructionFourMobile"
        [instructionFiveMobile]="translate.instructionFiveMobile"
        [instructionSixMobile]="translate.instructionSixMobile"
        [valueCode]="code"
      ></content-two-modal-mobile>
    </div>
  </div>
</modal>
